import React, { FC } from 'react';

import { IsoTimestamp, formatDateTimeRange, getLocalTimezone } from '@modernloop/shared/datetime';

import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

type Props = {
  proposedTime: {
    startAt: IsoTimestamp;
    endAt: IsoTimestamp;
  };
};

export const ProposedTimeContent: FC<Props> = ({ proposedTime }) => {
  const timezone = getLocalTimezone();

  const proposedTimeContent = `Proposal: ${formatDateTimeRange({
    start: proposedTime.startAt,
    end: proposedTime.endAt,
    timezone,
    showTzAbbr: true,
  })}`;

  return <ActivityLogContent content={proposedTimeContent} />;
};
